import { STATUS_OPTIONS } from 'partner360/entities/keyInitiatives/model/status'

export const AVAILABLE_STATUSES: string[] = STATUS_OPTIONS.map(({ key }) => key)
